import React from 'react';

const AccessibilityStatement = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-black to-gray-900 text-white py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-white mb-4">הצהרת נגישות</h1>
          <p className="text-gray-300 text-lg">מחויבות J CLASS MOTORS לנגישות דיגיטלית</p>
        </div>

        <div className="bg-black/50 backdrop-blur-sm border border-amber-500/20 rounded-2xl p-8 space-y-8">
          <div className="bg-amber-500/10 border border-amber-500/30 rounded-lg p-4 mb-8">
            <p className="text-amber-300 text-sm">
              <strong>הערה חשובה:</strong> הצהרת הנגישות הבאה הינה טיוטה בלבד ואינה מהווה ייעוץ משפטי. 
              יש להתייעץ עם עורך דין מוסמך המתמחה בחוק שוויון זכויות לאנשים עם מוגבלות.
            </p>
          </div>

          <section>
            <h2 className="text-2xl font-bold text-amber-400 mb-4 border-b border-amber-500/30 pb-2">
              1. מחויבותנו לנגישות
            </h2>
            <div className="text-gray-300 space-y-3">
              <p>
                J CLASS MOTORS מחויבת להנגיש את השירותים הדיגיטליים שלה לכלל הציבור, 
                כולל אנשים עם מוגבלויות, בהתאם לחוק שוויון זכויות לאנשים עם מוגבלות, התשנ"ח-1998.
              </p>
              <p>
                אנו פועלים להנגשת האתר בהתאם לתקן הישראלי ת"י 5568 ולהנחיות WCAG 2.1 ברמה AA.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-amber-400 mb-4 border-b border-amber-500/30 pb-2">
              2. מאפייני נגישות מיושמים
            </h2>
            <div className="text-gray-300 space-y-3">
              <p>האתר כולל את מאפייני הנגישות הבאים:</p>
              <ul className="list-disc list-inside space-y-2 mr-4">
                <li>ניווט באמצעות מקלדת בלבד</li>
                <li>תמיכה בקוראי מסך</li>
                <li>ניגודיות צבעים מתאימה</li>
                <li>טקסט ברור וקריא</li>
                <li>כותרות מובנות (H1, H2, H3...)</li>
                <li>תמונות עם טקסט חלופי (Alt text)</li>
                <li>טפסים נגישים עם תוויות ברורות</li>
                <li>קישורים עם תיאור ברור</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-amber-400 mb-4 border-b border-amber-500/30 pb-2">
              3. דפדפנים נתמכים
            </h2>
            <div className="text-gray-300 space-y-3">
              <p>האתר נבדק ונמצא תואם לדפדפנים הבאים:</p>
              <ul className="list-disc list-inside space-y-2 mr-4">
                <li>Chrome (גרסאות עדכניות)</li>
                <li>Firefox (גרסאות עדכניות)</li>
                <li>Safari (גרסאות עדכניות)</li>
                <li>Edge (גרסאות עדכניות)</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-amber-400 mb-4 border-b border-amber-500/30 pb-2">
              4. מוקד טלפוני נגיש
            </h2>
            <div className="text-gray-300 space-y-3">
              <p>
                לנוחותכם, ניתן לקבל את כל המידע והשירותים גם בטלפון:
              </p>
              <ul className="list-disc list-inside space-y-2 mr-4">
                <li><strong>טלפון:</strong> 058-7019669</li>
                <li><strong>שעות פעילות:</strong> ראשון-חמישי 09:00-18:00</li>
                <li><strong>השירות כולל:</strong> מידע על רכבים, תיאום פגישות, סיוע בתהליך הרכישה</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-amber-400 mb-4 border-b border-amber-500/30 pb-2">
              5. פניות בנושא נגישות
            </h2>
            <div className="text-gray-300 space-y-3">
              <p>
                אם נתקלת בבעיות נגישות או יש לך הצעות לשיפור, אנא פנה אלינו:
              </p>
              <ul className="list-disc list-inside space-y-2 mr-4">
                <li><strong>אחראי נגישות:</strong> מנהל האתר</li>
                <li><strong>טלפון:</strong> 058-7019669</li>
                <li><strong>דוא"ל:</strong> accessibility@jclassmotors.co.il</li>
                <li><strong>זמן תגובה:</strong> עד 7 ימי עבודה</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-amber-400 mb-4 border-b border-amber-500/30 pb-2">
              6. בקשות לנגישות חלופית
            </h2>
            <div className="text-gray-300 space-y-3">
              <p>
                במידה ונתקלת בקשיים בגישה למידע באתר, ניתן לפנות אלינו לקבלת המידע בצורה חלופית:
              </p>
              <ul className="list-disc list-inside space-y-2 mr-4">
                <li>מידע בטלפון</li>
                <li>שליחת חומרים במייל</li>
                <li>פגישה אישית בסניף</li>
                <li>מידע בפורמטים נוספים</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-amber-400 mb-4 border-b border-amber-500/30 pb-2">
              7. משוב ושיפור מתמיד
            </h2>
            <div className="text-gray-300 space-y-3">
              <p>
                אנו מתחייבים לשפר בהתמדה את נגישות האתר ולעדכן הצהרה זו בהתאם.
              </p>
              <p>
                המשוב שלך חשוב לנו ויסייע לנו להמשיך ולשפר את הנגישות.
              </p>
            </div>
          </section>

          <div className="border-t border-amber-500/30 pt-6 mt-8">
            <p className="text-gray-400 text-sm text-center">
              עדכון אחרון: {new Date().toLocaleDateString('he-IL')} | 
              J CLASS MOTORS - מחויבים לנגישות דיגיטלית לכולם
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessibilityStatement;